import React, { useState } from "react";
import PropTypes from "prop-types";
import Rating from "@mui/material/Rating";
import { SFStarBorderIcon, SFStarIcon} from "../icons";
import { SFStack } from "../grid";
import SFTypography from "../typography";
import getStyled from "../../hooks/getStyled";
import { FONT_FAMILIES } from "../../theme/styles";

const { styled } = getStyled();

const SFStarIconStyled = styled(SFStarIcon)(({ theme, variant }) => ({
  color: variant === "primary" ? theme.palette.grey500.main : "#FFC700",
}));

const SFTypographyStyled = styled(SFTypography)(({ theme, hover }) => ({
  ...FONT_FAMILIES.REGULAR,
  fontSize: 11,
  textTransform: "uppercase",
  fontWeight: 400,
  lineHeight: "15px",
  color: hover ? theme.palette.grey350.main : theme.palette.grey450.main,
}));

const Label = ({ hover, children, variant = null, hoverVariant = null }) => {
  if (variant && hoverVariant) {
    return (
      <SFTypography variant={hover ? hoverVariant : variant}>
        {children}
      </SFTypography>
    );
  }
  return <SFTypographyStyled variant="body1" hover={hover}>{children}</SFTypographyStyled>;
};

const SFRating = (props) => {
  const [hover, setHover] = useState(-1);
  const { variant, labelVariant, hoverLabelVariant, value, onChange, showAsDisabled, ...other } = props;
  let borderColor = "grey500";

  switch (variant) {
  case "primary":
    borderColor = "grey500";
    break;
  case "secondary":
    borderColor = "grey350";
    break;
  }

  const changeHandler = (event, newValue) => {
    onChange && onChange(newValue);
  };

  return (
    <SFStack direction="row" spacing={2} alignItems="center">
      <Rating
        value={props.value}
        onChange={changeHandler}
        onChangeActive={(event, newHover) => {
          setHover(newHover);
        }}
        icon={<SFStarIconStyled size={other.size} variant={variant} />}
        emptyIcon={(props.disabled || showAsDisabled) ? <SFStarIcon size={other.size} color={borderColor}/> : <SFStarBorderIcon size={other.size} color={borderColor}/>}
        precision={props.precision}
        {...other}
      />
      {other.labels && (
        <Label
          hover={hover !== -1}
          hoverVariant={hoverLabelVariant}
          variant={labelVariant}
        >
          {other.labels[hover !== -1 ? hover : props.value]}
        </Label>
      )}
    </SFStack>
  );
};

SFRating.defaultProps = {
  precision: 1,
  readOnly: false,
  size: "medium",
  variant: "primary",
  labelVariant: null,
  hoverLabelVariant: null,
  value: null,
};

SFRating.propTypes = {
  labels: PropTypes.object,
  value: PropTypes.number,
  precision: PropTypes.number,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  size: PropTypes.oneOf(["xsmall", "small", "medium", "large"]),
  variant: PropTypes.oneOf(["primary", "secondary"]),
  labelVariant: PropTypes.string,
  hoverLabelVariant: PropTypes.string,
};

export default SFRating;
